import { createContext, useContext, useState, useEffect } from 'react';

// ── Hardcoded user accounts ────────────────────────────────────────────────
// To add users: add entries to this object.
// Password is stored as a plain string here — fine for an internal tool.
// For production, replace with a backend auth service.
const USERS = {
  // Merissa — primary sales account
  'merissa@softglowlab.com': {
    password: 'SoftGlow2025!',
    name: 'Merissa',
    role: 'sales',
  },
  // Sales DL account
  'Sales': {
    password: 'SoftGlow2026!',
    name: 'Sales',
    role: 'sales',
  },


  // Add more accounts here:
  // 'name@softglowlab.com': { password: '...', name: 'Name', role: 'sales' },
};

const SESSION_KEY = 'sg_session';
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const saved = sessionStorage.getItem(SESSION_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const login = (identifier, password) => {
    const id = (identifier || '').toLowerCase().trim();
    // Case-insensitive lookup against USERS keys (so 'Sales', 'SALES',
    // 'sales' all match a key like 'Sales'). Falls back to the email
    // local-part so 'sales' matches 'sales@softglowlab.com'.
    let resolvedKey = null;
    let account = null;
    for (const k of Object.keys(USERS)) {
      const kl = k.toLowerCase();
      if (kl === id || kl.split('@', 1)[0] === id) {
        resolvedKey = k;
        account = USERS[k];
        break;
      }
    }
    if (!account) return { ok: false, error: 'Username not found.' };
    if (account.password !== password) return { ok: false, error: 'Incorrect password.' };
    const sessionUser = { email: resolvedKey, name: account.name, role: account.role };
    setUser(sessionUser);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionUser));
    return { ok: true };
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem(SESSION_KEY);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
